import * as React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { useLoaderData, useNavigate } from 'react-router-dom'
import PageAppBar from 'components/PageAppBar'
import { BadgeModel } from 'types'
import BadgeDataGrid from 'components/BadgeDataGrid'

export default function BadgesPage() {
  const badges = useLoaderData() as BadgeModel[]
  const navigate = useNavigate()

  return (
    <PageAppBar pageName="Gestion des Badges">
      <Box
        sx={{
          padding: '1rem',
          height: 'calc(100vh - 64px)',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 1,
          }}
        >
          <Button variant="contained" onClick={() => navigate('/badge/create')}>
            Créer un Badge
          </Button>
        </Box>

        <Box sx={{ flexGrow: 1, width: '100%' }}>
          <BadgeDataGrid badges={badges} />
        </Box>
      </Box>
    </PageAppBar>
  )
}
